import styled from 'styled-components';
import { colors } from '@/template/styles';

export const Container = styled.div`
  padding: 1rem;
`;

export const SectionTitle = styled.h4`
  font-size: 1.6rem;
  font-weight: bold;
  color: ${colors.dark};
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid ${colors.gray};
  padding-bottom: 0.5rem;
`;

export const SectionHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid ${colors.gray};
  padding-bottom: 0.5rem;
`;

export const SectionTitleNoBorder = styled.h4`
  font-size: 1.6rem;
  font-weight: bold;
  color: ${colors.dark};
  margin: 0;
`;

export const FaixaCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
  position: relative;
`;

export const FaixaHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed #dee2e6;
`;

export const FaixaTitle = styled.span`
  font-weight: 700;
  font-size: 1.25rem;
  color: ${colors.dark || '#333'};
`;

export const RemoveFaixaButton = styled.button`
  background: transparent;
  border: none;
  color: ${colors.danger || '#dc3545'};
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(220, 53, 69, 0.1);
  }
`;

export const EmptyFaixasNotice = styled.div`
  padding: 1.5rem;
  text-align: center;
  background-color: #f8f9fa;
  border: 1px dashed #ccc;
  border-radius: 8px;
  color: #6c757d;
  margin-bottom: 1.5rem;
  font-size: 1rem;
`;

export const SwitcherWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 50px;
  margin-bottom: 1.5rem;
  padding-bottom: 5px;
`;

export const SwitcherInputGroup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
  width: 100%;
  
  .switcher-container {
    flex: 0 0 auto;
    margin-bottom: 1.5rem;
  }
  
  .input-container {
    flex: 1 1 auto;
  }
`;

export const AddFaixaButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: transparent;
  color: ${colors.blue || '#007bff'};
  border: 1px solid ${colors.blue || '#007bff'};
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${colors.blue || '#007bff'};
    color: #fff;
  }
`;

export const TypeSelectorGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`;

export const TypeSelectorLabel = styled.label`
  font-size: 0.95rem;
  font-weight: 600;
  color: ${colors.dark || '#333'};
  margin-bottom: 0.5rem;
`;

export const TypeSegmentContainer = styled.div`
  display: flex;
  background-color: #e9ecef;
  border-radius: 6px;
  padding: 3px;
  gap: 4px;
  width: 100%;
`;

export const TypeSegmentButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 12px;
  font-size: 0.92rem;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  background-color: ${(props) => (props.active ? colors.blue || '#007bff' : 'transparent')};
  color: ${(props) => (props.active ? '#ffffff' : '#495057')};
  box-shadow: ${(props) => (props.active ? '0 2px 4px rgba(0,123,255,0.25)' : 'none')};

  &:hover {
    color: ${(props) => (props.active ? '#ffffff' : colors.blue || '#007bff')};
  }
`;
